'use client';

import type { AuthorLevel } from '@/features/original-plus/constants';
import { useAuthorLevelsApplication } from '@/features/original-plus/context/use-author-levels-application';

const panelPriceClassName =
  'roboto-flex-compressed text-center font-extra-black text-[28px] uppercase leading-[100%] tracking-normal text-[#F4F4F4]';

const panelPriceCaptionClassName =
  'mt-1 text-center font-sans text-[11px] font-normal leading-[16px] tracking-normal text-[#888C91]';

const panelCtaButtonClassName =
  'inline-flex w-full shrink-0 items-center justify-center rounded-[12px] px-4 py-3.5 font-sans text-[14px] font-bold leading-[120%] tracking-normal transition-[filter] duration-200 hover:brightness-[1.08] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/30';

type AuthorLevelsPanelCtaProps = {
  level: AuthorLevel;
};

export function AuthorLevelsPanelCta({ level }: AuthorLevelsPanelCtaProps) {
  const { applyForLevel } = useAuthorLevelsApplication();

  return (
    <div className="mt-auto pt-4">
      <div className="flex flex-col gap-3 border-t border-[#FFFFFF29] pt-4">
        <div className="text-center">
          <p className={panelPriceClassName}>{level.panel.price}</p>
          {level.panel.priceCaption ? (
            <p className={panelPriceCaptionClassName}>{level.panel.priceCaption}</p>
          ) : null}
        </div>
        <button
          type="button"
          className={panelCtaButtonClassName}
          style={{
            backgroundColor: level.panelThemeColor,
            color: level.panel.ctaTextColor,
          }}
          onClick={() => applyForLevel(level.id)}
        >
          {level.panel.ctaLabel}
        </button>
      </div>
    </div>
  );
}
